<div *ngIf="!isCompanyLoading" class="apt-main" #wizardScroller>
  <div class="apt-main-body" [ngClass]="{'flex-center-center':!isFirstTimeLoad}">
    <div class="appointment-request content-center row" [hidden]="!isFirstTimeLoad" *ngIf="companySetting">
      <div class="col-12 p-0">
        <div class="apt-header-wrapper mb-4 pb-3">
          <div class="company-logo-wrapper" *ngIf="companyLogo">
            <img [src]="companyLogo" alt="AutoLeap Logo" class="company-logo">
          </div>
          <div class="heading">
            <div class="appointment-heading">
              <h2 class="mb-0">{{companySetting.name}}</h2>
            </div>
          </div>
        </div>
      </div>

      <div class="appointment-body col-12">
        <!-- <div class="heading">
          <div class="appointment-heading">
            <h3 *ngIf="isApptRequestPortalEnabled" class="mb-0">
              {{'appointment.appointment-booking-form'|translate}}
            </h3>
          </div>
        </div> -->
        <div class="flex-start-center justify-content-between px-md-0 px-3">
          <div class="w-100" [ngClass]="fourthStepper ? 'flex-end-center' : 'flex-between-center'">
            <div class="apt-icon-text-heading-wrapper" *ngIf="!fourthStepper" [hidden]="!isApptRequestPortalEnabled">
              <div class="calendar-bg">
                <i *ngIf="firstStepper" class="fal fa-calendar-alt"></i>
                <i *ngIf="secondStepper" class="far fa-user"></i>
                <i *ngIf="thirdStepper && company" class="fal fa-calendar-check"></i>
              </div>
              <div>
                <div class="time-slot sub-heading">
                  <h3 *ngIf="firstStepper" class="mb-0">{{'appointment.select-a-time-slot'|translate}}</h3>
                  <h3 *ngIf="secondStepper" class="mb-0">{{'appointment.enter-your-details' | translate}}</h3>
                  <h3 *ngIf="thirdStepper && company" class="mb-0">{{'appointment.verify-request-details'|translate}}
                  </h3>
                  <!-- <p>{{'appointment.tell-us-your-preferred-time-to-visit-our-workshop'|translate}}</p> -->
                </div>
              </div>
            </div>
            <div class="globe-icon" (click)="toggleLanguageDropdown()" *ngIf="companyLocalization">
              <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
              <span class="lang">
                {{currentLang?.toUpperCase()}}
              </span>
              <div *ngIf="isLanguageDropdownVisible" class="language-dropdown">
                <div (click)="switchLanguage('en')">
                  English
                </div>
                <div (click)="switchLanguage('fr')">
                  French (Français)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="campaign && campaign.showLeadSource" class="flex-center-center px-md-0 px-3">
          <div class="lead-source d-flex p-2">
            <div class="m-icon">
              <i class="fal fa-megaphone"></i>
            </div>
            <!-- <p class="mb-0 pl-2 pr-1">Source:</p> -->
            <b>{{campaign.title}}</b>
          </div>

        </div>

        <div class="slidecontainer px-md-0 px-3" *ngIf="isApptRequestPortalEnabled">
          <div class="slider">
            <div class="selected-slider"
              [ngClass]="[secondStepper?'width-50':thirdStepper?'width-75':fourthStepper?'width-100':'']">
              <!-- :fourthStepper?'width-100' -->
            </div>
          </div>
        </div>
        <div class="card" *ngIf="isApptRequestPortalEnabled">
          <div class="card-body px-md-0 px-3 pt-0">

            <!-- First Step -->
            <ng-container *ngIf="firstStepper">
              <div class="step-wizard">
                <div class="sub-heading">
                  <h4>{{'appointment.select-preferred-date'|translate}}</h4>
                </div>
                <div class="justify-content-center" [hidden]="isFindingActiveWeek">
                  <app-date-filter [period]="activeView" [selectedDateTime]="defaultStartDate"
                    (appChange)="handleDateChange($event)" [currentLang]="currentLang" [token]="token"
                    [minimumDate]="minimumDate" [isPeriodSelectionVisible]="isCustomerView">
                  </app-date-filter>
                </div>

                <div *ngIf="isFindingActiveWeek" class="loading-spinner">
                  <i class="fas fa-spinner fa-spin"></i>
                  Loading available dates...
                </div>

                <div class="date-time-slider mt-4" [hidden]="isFindingActiveWeek">
                  <div class="box-section" #target>
                    <!-- [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'selectedDay':'',!day.isDisable?'not-allowed':'']" -->
                    <div class="day-box pointer" #dayBox *ngFor="let day of daysOfWeek; let i = index"
                      (click)="onDaySelect(day, null, true)" [ngClass]="{
                        'selectedDay': day.isDisable && (day.day | date:'yyyy-MM-dd') === (userInfo?.selectedDay?.day | date:'yyyy-MM-dd'),
                        'not-allowed': !day.isDisable
                      }">
                      <!-- ,day.isDisable?'not-allowed':'' -->
                      <div class="month-date-day" [ngSwitch]="day.day | date:'EEE'">
                        <div class="gray-55 font-14" *ngSwitchCase="'Mon'" class="font-14">{{'weekDays.mon'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Tue'" class="font-14">{{'weekDays.tue'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Wed'" class="font-14">{{'weekDays.wed'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Thu'" class="font-14">{{'weekDays.thu'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Fri'" class="font-14">{{'weekDays.fri'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Sat'" class="font-14">{{'weekDays.sat'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchCase="'Sun'" class="font-14">{{'weekDays.sun'|translate}}
                        </div>
                        <div class="gray-55 font-14" *ngSwitchDefault class="font-14">Unknown Day</div>
                      </div>
                      <!-- <div class="gray-55 font-14">{{day.day | date:'EEE'}}</div> -->
                      <div class="black month-date">{{day.day | date:'d'}}</div>
                      <!-- <div class="gray-55 font-14 month">{{(day.day | date:'MMM')}}</div> -->
                      <div class="month-name-wrapper" [ngSwitch]="day.day | date:'MMM'">
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Jan'">{{'months-full.jan'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Feb'">{{'months-full.feb'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Mar'">{{'months-full.mar'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Apr'">{{'months-full.apr'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'May'">{{'months-full.may'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Jun'">{{'months-full.jun'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Jul'">{{'months-full.jul'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Aug'">{{'months-full.aug'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Sep'">{{'months-full.sep'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Oct'">{{'months-full.oct'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Nov'">{{'months-full.nov'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchCase="'Dec'">{{'months-full.dec'|translate}}</div>
                        <div [ngClass]="[selectedDay.length>0 && selectedDay[0] === day.id?'font-primary':'']"
                          class="gray-55 font-14" *ngSwitchDefault>Unknown Month</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="errors.selectDay" class="apperror p-top-5">
                  {{errors.selectDay === 'Day required'?('day-required'|translate):error.selectDay}}</div>

                <div class="sub-heading mt-4" [hidden]="isFindingActiveWeek"
                  *ngIf="selectedDay && selectedDay.length>0">
                  <h4>{{'appointment.select-preferred-time'|translate}}</h4>
                </div>
                <div class="mb-4">
                  <div class="time-for" *ngIf="selectedDay && selectedDay.length>0">
                    <div class="p-0 set-time day-breakdown-wrapper" *ngFor="let day of availableDates"
                      [ngClass]="{'d-none':day.hrs && day.hrs.length === 0}">
                      <div *ngIf="day.hrs && day.hrs.length > 0" (click)="onTimeCategorySelect(day)"
                        class="day-button pointer"
                        [ngClass]="{'selectedTime':selectedTimeCategory.length>0 && selectedTimeCategory[0] === day.name}">
                        <span class="for-selected-day">
                          {{day.name === 'Morning' ? ('appointment.morning'|translate) : day.name === 'Mid-day' ?
                          ('appointment.mid-day'|translate) : day.name === 'Evening'
                          ?('appointment.evening'|translate):day.name}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="time-off" *ngIf="selectedTimeCategory && selectedTimeCategory.length>0">
                    <div class="day-button pointer" *ngFor="let day of timeSlot; let i = index"
                      (click)="onTimeSlotSelect(day)" [ngClass]="{
       'selectedTime': (selectedTimeSlot.length > 0 && selectedTimeSlot[0] === day.value) || (selectedTimeSlot.length === 0 && i === 0)
     }">
                      {{ day.hr }}
                    </div>

                  </div>
                  <div *ngIf="errors.selectTime && selectedDay && selectedDay.length>0" class="apperror">
                    {{errors.selectTime === 'Time required'?('time-required'|translate):error.selectTime}}
                  </div>
                </div>
                <div *ngIf="customerDetails?.isVehicleDropOffVisible">
                  <div class="sub-heading mb-4">
                    <h4>{{'appointment.will-you-be-dropping-off-your-vehicle'|translate}}</h4>
                  </div>
                  <div>
                    <div class="mt-3" *ngFor="let radio of dropOffs">
                      <app-radio-button class="droppin-vehicle"
                        [label]="radio === 'I will wait with my vehicle' ?
                        ('appointment.i-will-wait-with-my-vehicle' | translate) : ('appointment.i-will-drop-off-my-vehicle' | translate)"
                        (appChange)="handleChangeDropOff(radio)" [selectedValue]="userInfo.vehicleDropoff"
                        [value]="radio"> </app-radio-button>
                    </div>
                    <div *ngIf="errors.dropOff" class="apperror">{{errors.dropOff === 'Drop-off required'?
                      ('drop-off-required'|translate):error.dropOff}}</div>
                  </div>
                </div>
              </div>

            </ng-container>


            <!-- Second Step -->
            <ng-container *ngIf="secondStepper">
              <!-- <div class="d-flex">
                <div class="calendar-bg">
                  <i class="far fa-user"></i>
                </div>
                <div>
                  <div class="time-slot sub-heading">
                    <h3>{{'appointment.enter-your-details' | translate}}</h3>
                    <p>{{'appointment.please-provide-your-name-and-contact-details' | translate}}</p>
                  </div>
                </div>
              </div> -->
              <div class="step-wizard second-stepper">
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-user"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="first-name" validationId="error-first-name"
                      [placeholder]="'appointment.first-name' | translate" [floatingLabel]="true" [maxLength]="25"
                      (appChange)="handleChangeName('firstName',$event)" [isInvalid]="errors?.firstName"
                      [value]="userInfo.firstName" [errorMessage]="'first-name-required'|translate">
                    </app-input>
                  </div>
                </div>
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-user"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="last-name" validationId="error-last-name"
                      [placeholder]="'appointment.last-name' | translate" [floatingLabel]="true" [maxLength]="25"
                      (appChange)="handleChangeName('lastName',$event)" [value]="userInfo.lastName"
                      [isInvalid]="errors?.lastName" [errorMessage]="'last-name-required'|translate">
                    </app-input>
                  </div>
                </div>
                <div class="ui-g-12 p-0">
                  <div class="ui-g-12 form-field mb-0">
                    <div class="form-icon">
                      <!-- <i class="fal fa-mobile gray-55"></i> -->
                      <i class="fas fa-mobile-alt gray-55"></i>
                    </div>
                    <div class="input-box">
                      <app-input id="phone" validationId="error-phone"
                        [placeholder]="'appointment.mobile-number' | translate" [isInvalid]="errors?.phone"
                        [errorMessage]="errors.phone === 'Mobile number required' ? ('mobile-number-required'|translate) : ('phone-is-not-valid'|translate)"
                        mask="(000) 000-0000" [floatingLabel]="true" (appChange)="handleChangeName('phone',$event)"
                        [value]="userInfo.phone">
                      </app-input>
                    </div>
                  </div>
                  <label class="gray-55 mb-3 font-12 mt-3" [ngClass]="{'mt-3':errors?.phone}">
                    {{'appointment.please-provide-mobile-so-you-could-receive-confirmation-sms-from-us'|translate}}
                  </label>
                </div>

                <!-- Email -->
                <div class="ui-g-12 form-field">
                  <div class="form-icon">
                    <i class="far fa-envelope gray-55"></i>
                  </div>
                  <div class="input-box">
                    <app-input id="email" type="text" placeholder="Email" style="flex: 0 0 275px;" maxlength="50"
                      *ngIf="isApptRequestPortalEnabled" [placeholder]="'appointment.email' | translate" [fontSize]="14"
                      [errorMessage]="'email-is-not-valid'|translate" [isInvalid]="errors.email" [floatingLabel]="true"
                      [value]="userInfo.email" (appChange)="handleChangeName('email',$event)">
                    </app-input>
                  </div>
                </div>

                <!-- Adding consent checkboxes -->
                <div class="ui-g-12 form-field mb-1">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <app-checkbox inputId="apt-sms-template" [label]="
                      ( 'appointment.i-consent-to-receive-appointment-reminders' | translate ) +
                      ' ' + companySetting?.name +'. '" [isChecked]="isOperationalNotifEnabled"
                      (appChange)="handleChangeName('isOperationalNotifEnabled', $event === true || $event === 'true')">
                    </app-checkbox>
                  </div>
                </div>

                <!-- Discount/promotional consent checkbox -->
                <div class="ui-g-12 form-field mb-1">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <app-checkbox inputId="apt-discount-template" [label]="
                    ( 'appointment.i-consent-to-receive-promotional-offers' | translate ) +
                    ' ' + companySetting?.name +'. '" [isChecked]="isMarketingNotifEnabled"
                      (appChange)="handleChangeName('isMarketingNotifEnabled', $event === true || $event === 'true')">
                    </app-checkbox>
                  </div>
                </div>

                <!-- Privacy policy -->
                <div class="ui-g-12 form-field mb-1">
                  <!-- <div class="form-icon">
                  </div> -->
                  <div class="input-box consent-lables">
                    <p class="font-11">
                      {{ 'appointment.privacy-policy-text' | translate }}
                      <a class="primary-500" [routerLink]="['/customer-appointment-request/privacy-policy', token]"
                        [queryParams]="{ localization: true, lang: currentLang }" target="_blank"
                        rel="noopener noreferrer">
                        {{ 'appointment.privacy-policy-link' | translate }}</a>.
                    </p>

                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Third Step -->
            <ng-container *ngIf=" thirdStepper && company">
              <!-- <div class="d-flex">
                <div class="calendar-bg">
                  <i class="fal fa-calendar-check"></i>
                </div>
                <div>
                  <div class="time-slot sub-heading">
                    <h3>
                      {{'appointment.verify-request-details'|translate}}
                    </h3>
                    <p>
                      {{'appointment.review-the-following-and-you-are-all-set'|translate}}
                    </p>
                  </div>
                </div>
              </div> -->
              <div class="step-wizard thirdStepper">
                <div class="c-appt-info">
                  <div class="user-info">
                    <div class="calendar-bg">
                      <i class="fal fa-calendar-check "></i>
                    </div>

                    <div>
                      <div class="time-slot sub-heading font-14">
                        <h5>
                          {{userInfo?.selectedDay && (currentLang === 'fr' ?
                          dateService.formatDate(userInfo.selectedDay.day, 'MMMM D, YYYY', 'fr') :
                          dateService.formatDate(userInfo.selectedDay.day, 'MMM D, YYYY'))}}&nbsp;-&nbsp;
                          <span class="text-transform-uppercase">
                            {{userInfo.selectedTime && userInfo.selectedTime.hr}}
                          </span>
                        </h5>
                      </div>
                      <!-- <div class="prefer-time font-14">
                        Request ID: AR{{company.code}} </div> -->
                    </div>
                  </div>

                  <div class="user-info">
                    <div class="calendar-bg">
                      <i class="far fa-user "></i>
                    </div>
                    <div>
                      <div class="time-slot sub-heading font-14">
                        <h5>{{userInfo?.firstName}} {{userInfo?.lastName}}</h5>
                        <p>{{userInfo?.phone}}&nbsp;{{userInfo?.email?"| ":""}}{{userInfo?.email}}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="time-slot sub-heading mt-3 mt-md-4" *ngIf="!customerDetails?.isVehicleMandatory">
                  <h3>
                    {{'appointment.optional-information'|translate}}
                  </h3>
                </div>

                <div class="otpinfo mt-4">
                  <div class="single-info">
                    <div class="opt-info-dd">
                      <div class="info-title flex-between-center" hidden (click)="onSelectVehicle()">
                        <h3>
                          <i class="far gray-55 mr-2"
                            [ngClass]="[showVehicleDropdown?'fa-chevron-down':'fa-chevron-right']"></i>
                          {{selectVehicle}}
                        </h3>
                        <i class="fas fa-check-circle" *ngIf="selectVehicle !== 'Select Vehicle'"></i>
                      </div>
                      <!-- *ngIf="showVehicleDropdown" -->
                      <div>
                        <div class="ui-g-12 form-field">
                          <div class="form-icon">
                            <i class="fal fa-car gray-55"></i>
                          </div>
                          <div class="input-box">
                            <div class="mt-0 mb-3 gray-35 add-vehicle" [ngClass]="{ 'active': focus?.vehicle }">
                              {{'appointment.add-a-new-vehicle'|translate}}
                            </div>
                            <app-auto-complete id="ac-vehicle" listId="ac-vehicle-list"
                              label="{{'invoice.vehicle'|translate}}" itemWidth="100%" theme="primary"
                              noRecordIcon="far fa-car  font-16 pr-2" noRecordText="No vehicle match your search"
                              [placeholder]="'search-VIN-or-year-make-model'|translate" [textTruncate]="true"
                              [fontSize]="14" [suggestions]="vehicleSuggestions" [floatingLabel]="true"
                              [hasCustomEditableField]="focus?.vehicle || query?.vehicle" [autoFocus]="focus?.vehicle"
                              [isInvalid]="errors?.vehicle" [errorMessage]="errors?.vehicle" [isLoading]="isLoading"
                              [value]="vehicle?.title" [closeOnSelection]="true"
                              (appCompletedMethod)="onSearchVehicle($event)" (appClickInput)="handleFocus('vehicle')"
                              (appClickOutside)="handleBlur('vehicle')" [hasCustomListTemplate]="true"
                              (appChange)="handleChange('vehicle', $event)" (appClear)="onSuggestionsClear('vehicle')"
                              scrollHeight="186px">
                              <!-- <ng-template let-item appTemplate="item">
                              <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                                <div class="flex-between-center">
                                  <p class="m-0" [innerHTML]="item?.htmlName"></p>
                                  <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                                    [innerHTML]="item?.htmlLicensePlate">
                                  </p>
                                </div>
                                <div class="flex-between-center">
                                  <p class="m-0 font-gray-35 font-12" [innerHTML]="item?.htmlEngine"></p>
                                  <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin" [innerHTML]="item?.htmlVin">
                                  </p>
                                </div>
                              </div>
                            </ng-template> -->
                              <!-- (appSelect)="onVehicleSelect($event)" -->
                              <ng-template let-query="query" let-selectedIndex="selectedIndex" let-close="close"
                                appTemplate="list">
                                <li class="loading text-center p-3" *ngIf="isLoading">
                                  <i class="fas fa-spinner fa-spin mr-2"></i> {{'searching' | translate}}...
                                </li>
                                <li class="no-record-found text-left p-2"
                                  *ngIf="vehicleSuggestions?.length === 0 && isVehicleSearchTriggered && !isLoading">
                                  {{'no-searches-found' | translate}}
                                </li>

                                <li class="font-12 font-600 p-2 bt-1 source-suggestions-label active-vehicle-header"
                                  *ngIf="vehicleType?.active?.length > 0">
                                  <p class="mb-0">{{'appointment.active-vehicles' | translate}}</p>
                                </li>
                                <li class="source-suggestions-local">
                                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                                    <li class="font-12 font-black p-2 source-suggestion-label"
                                      *ngFor="let item of vehicleType?.active; let i = index" id="item-{{ i }}"
                                      (click)="onVehicleSelect(item, close)">
                                      <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                                        <div class="flex-between-center">
                                          <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                                            [innerHTML]="item?.htmlLicensePlate">
                                          </p>
                                          <p class="m-0" [innerHTML]="item?.htmlName"></p>

                                        </div>

                                        <div class="flex-between-center">
                                          <!-- <p class="m-0 font-gray-35 font-12">
                                          {{ 'technician.engine' | translate }}: {{ item?.htmlEngine.split(':')[1] }}
                                        </p>
                                        <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin">
                                          {{ 'technician.VIN' | translate }}: {{ item?.htmlVin.split(':')[1] }}
                                        </p> -->

                                          <p class="m-0 font-gray-35 font-12">
                                            {{ 'technician.engine' | translate }}:
                                            <span [innerHTML]="sanitizeHtml(item?.htmlEngine.split(':')[1])"></span>
                                          </p>

                                          <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin">
                                            {{ 'technician.VIN' | translate }}:
                                            <span [innerHTML]="sanitizeHtml(item?.htmlVin.split(':')[1])"></span>
                                          </p>

                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </li>

                                <li class="font-12 font-600 p-2 bt-1 source-suggestions-label in-active-header"
                                  *ngIf="vehicleType.inactive?.length > 0">
                                  <p class="mb-0"> {{'appointment.inactive-vehicles' | translate}}</p>
                                </li>
                                <li class="source-suggestions-local in-active-list">
                                  <ul class="source-suggestions-local-list" id="e-serviceItem-local-source">
                                    <li class="font-12 font-black p-2 source-suggestion-label archived"
                                      *ngFor="let item of vehicleType?.inactive; let j = index" id="item-{{ j }}">
                                      <div class="width-100p font-14 p-2 flex-column" [hidden]="item?.isHeader">
                                        <div class="flex-between-center">
                                          <p class="m-0 search-license-plate" [hidden]="!item?.htmlLicensePlate"
                                            [innerHTML]="item?.htmlLicensePlate">
                                          </p>
                                          <p class="m-0" [innerHTML]="item?.htmlName"></p>
                                        </div>

                                        <div class="flex-between-center">
                                          <p class="m-0 font-gray-35 font-12">
                                            {{ 'technician.engine' | translate }}:
                                            <span [innerHTML]="sanitizeHtml(item?.htmlEngine.split(':')[1])"></span>
                                          </p>

                                          <p class="m-0 font-gray-35 font-12" *ngIf="item?.htmlVin">
                                            {{ 'technician.VIN' | translate }}:
                                            <span [innerHTML]="sanitizeHtml(item?.htmlVin.split(':')[1])"></span>
                                          </p>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </li>
                              </ng-template>

                              <ng-template appTemplate="editable">
                                <div id="create-vehicle" class="width-100p py-2" (click)="openCreateVehicle()">
                                  <span class="font-700 font-16" *ngIf="vehicleSuggestions?.length >= 1">
                                    {{'appointment.add-vehicle' | translate}} +
                                  </span>
                                  <span class="font-700 font-16"
                                    *ngIf="vehicleSuggestions?.length === 0">
                                    {{'add-vehicle-details' | translate}} +
                                  </span>
                                </div>
                              </ng-template>
                            </app-auto-complete>
                          </div>
                        </div>

                        <div class="ui-g-12 input-row vehicle-row mb-1 overflow-scroll px-0"
                          [hidden]="!isCreateVehicleMode">
                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <div class="input-box">
                              <app-input id="v-year" type="text" theme="primary"
                                [placeholder]="customerDetails?.isVehicleMandatory ? ('appointment.year' | translate) + ' *' : ('appointment.year' | translate)"
                                [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.year" [mask]="'0000'"
                                [isInvalid]="errors?.year" [errorMessage]="errors?.year"
                                [autoFocus]="isCreateVehicleMode" (appChange)="handleChange('year', $event)">
                              </app-input>
                            </div>
                          </div>

                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <div class="input-box">
                              <app-input id="v-make" type="text" theme="primary"
                                [placeholder]="customerDetails?.isVehicleMandatory ? ('appointment.make' | translate) + ' *' : ('appointment.make' | translate)"
                                [maxLength]="35" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.make"
                                [isInvalid]="errors?.make" [errorMessage]="errors?.make"
                                (appChange)="handleChange('make', $event)">
                              </app-input>
                            </div>
                          </div>

                          <div class="ui-g-12 form-field mt-2 inherit-fields">
                            <div class="input-box">
                              <app-input id="v-model" type="text" theme="primary"
                                [placeholder]="customerDetails?.isVehicleMandatory ? ('appointment.model' | translate) + ' *' : ('appointment.model' | translate)"
                                [maxLength]="35" [fontSize]="14" [floatingLabel]="true" [value]="vehicle?.model"
                                [isInvalid]="errors?.model" [errorMessage]="errors?.model"
                                (appChange)="handleChange('model', $event)">
                              </app-input>
                            </div>
                          </div>
                          <!-- <div class="ui-g-12 ui-lg-12 justify-content-end d-flex">
                            <button class="btn save-vehicle" (click)="onSaveVehicle()">
                              Save details
                            </button>
                          </div> -->
                        </div>
                      </div>
                      <div *ngIf="errors.selectVehicle" class="apperror mt-1">{{errors.selectVehicle}}</div>
                    </div>
                  </div>
                  <div class="time-slot sub-heading mt-3 mt-md-4" *ngIf="customerDetails?.isVehicleMandatory">
                    <h3>{{'appointment.optional-information'|translate}}</h3>
                  </div>
                  <div class="single-info">
                    <div class="opt-info-dd">
                      <div class="info-title flex-between-start" hidden (click)="onSelectService()">
                        <h3>
                          <i class="far gray-55 mr-2"
                            [ngClass]="[showServiceDropdown?'fa-chevron-down':'fa-chevron-right']"></i>
                          <span
                            *ngIf="!serviceText && !isSelectedService">{{'appointment.add-services'|translate}}</span>
                          <span *ngIf="serviceText">{{'appointment.services-added'|translate}}</span>
                        </h3>
                        <i class="fas fa-check-circle" *ngIf="serviceText"></i>
                      </div>
                      <div class="ser-dd mt-4">
                        <div class="overflow-scroll service-dd">
                          <app-content-overlay [dropshadow]="true" [showArrow]="false" (appShow)="onOverlayShow()"
                            (appHide)="onOverlayClose()" class="apt-content-overlay"
                            [ngClass]="{ 'active': isServiceOverlayVisible }">
                            <ng-template appTemplate="item">
                              <div class="ui-g-12 form-field">
                                <div class="form-icon">
                                  <i class="fal fa-tools gray-55"></i>
                                </div>
                                <div class="input-box">
                                  <div class="filter-pill-inner-wrapper d-flex">
                                    <div class="filter-text w-90px text-overflow-ellipsis float-label">
                                      <span>
                                        {{'appointment.select-your-services' | translate}}
                                      </span>
                                    </div>
                                    <div class="filter-text w-90px text-overflow-ellipsis">
                                      <span *ngIf="serviceText" class="black">
                                        {{serviceText ? serviceText : ('appointment.select-your-services' | translate)}}
                                      </span>
                                      <span *ngIf="!serviceText">
                                        e.g {{'brake-oil-change' | translate}}
                                      </span>
                                    </div>
                                    <div class="filter-cross">
                                      <i class="fas fa-caret-down"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template appTemplate="overlay" style="right:0px !important">
                              <div class="font-13 font-600 font-gray-45 labor-suggestion-label"
                                *ngFor="let category of serviceCategories;let catIndex = index">
                                <p class="service-category-heading pt-3 pb-2"
                                  [innerHTML]="helperService.getLocalizationValue(currentLang, category, 'name')">
                                </p>

                                <div class="ddl-empty-state-wrapper d-flex w-100 py-2 border-bottom"
                                  *ngFor="let service of category.services;let i = index">
                                  <div class="empty-list-icon font-12 font-gray-75 pr-2 align-self-center">
                                    <app-checkbox label="" [isChecked]="service.isHidden"
                                      (appChange)="handleCheckboxChange(catIndex,i,service, $event)">
                                    </app-checkbox>
                                  </div>

                                  <div class="empty-list-text">
                                    <p class="mb-0"
                                      [innerHTML]="helperService.getLocalizationValue(currentLang, service, 'name')">
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </app-content-overlay>
                          <div>
                            <div class="ui-g-12 form-field mt-4 textarea">
                              <div class="form-icon">
                                <!-- <i class="fal fa-tools gray-55"></i> -->
                              </div>
                              <div class="input-box">
                                <div class="font-12 gray-35 add-vehicle" [ngClass]="{ 'active': focus?.notes }">
                                  {{'appointment.please-describe-your-concern'|translate}}
                                </div>
                                <app-textarea [placeholder]="'e.g ' + ('i-am-facing-a-problem-with-my-brakes' | translate)" theme="border"
                                  [rows]="4" (appChange)="handleChangeName('notes',$event)"
                                  (appFocus)="handleFocus('notes')" (appBlur)="handleBlur('notes')"
                                  [value]="userInfo.notes" [isInvalid]="errors?.notes" [errorMessage]="errors?.notes">
                                </app-textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="errors.selectService" class="apperror mt-1">{{errors.selectService}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3"></div>
              </div>
            </ng-container>

            <!-- Fourth Step -->
            <ng-container *ngIf="fourthStepper">
              <div class="step-wizard mt-0">
                <div>
                  <div class="time-slot sub-heading">
                    <h3> {{'appointment.thank-you-for-choosing'|translate}} {{companySetting.name}}!</h3>
                    <p>{{'appointment.we-have-received-your-booking-for'|translate}}
                      <strong>{{ userInfo?.selectedDay && dateService.formatDateWithLocale(userInfo.selectedDay.day,
                        currentLang === 'fr' ? 'MMMM D, yyyy' : 'MMM D, yyyy', currentLang) }} at
                        {{confirmedDate | date:'h:mmaa'}}</strong>. {{'appointment.here-is-your-booking-id'|translate}}:
                      <strong>{{code}}</strong>.
                      {{'appointment.we-will-reach-out-to-you-soon-with-a-confirmation'|translate}}
                    </p>

                  </div>
                </div>
              </div>
              <div class="fourthStepper">
                <div class="mt-3">
                  <div class="c-appt-info">
                    <div class="user-info width-100">
                      <div class="calendar-bg">
                        <i class="fal fa-calendar-check "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>
                            {{userInfo?.selectedDay && (currentLang === 'fr' ?
                            dateService.formatDate(userInfo.selectedDay.day, 'MMMM D, YYYY', 'fr') :
                            dateService.formatDate(userInfo.selectedDay.day, 'MMM D, YYYY'))}}
                            &nbsp;-&nbsp;{{userInfo.selectedTime.hr}}
                          </h5>
                          <p>
                            {{'appointment.booking-id'|translate}}: APR#{{code}}
                            <span class="mx-2">|</span>
                            <ng-container
                              *ngIf="userInfo?.vehicleDropoff === dropOffs[1]">{{'appointment.i-will-drop-off-my-vehicle'
                              | translate}}
                            </ng-container>
                            <ng-container
                              *ngIf="userInfo?.vehicleDropoff === dropOffs[0]">{{'appointment.i-will-wait-with-my-vehicle'
                              | translate}}
                            </ng-container>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100">
                      <div class="calendar-bg">
                        <i class="far fa-user "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>{{userInfo?.firstName}} {{userInfo?.lastName}}</h5>
                          <p>{{userInfo?.phone}}&nbsp;{{userInfo?.email?"| ":""}}{{userInfo?.email}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100" *ngIf="selectVehicle && selectVehicle != 'Select Vehicle'">
                      <div class="calendar-bg">
                        <i class="far fa-car "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>{{selectVehicle}}</h5>
                        </div>
                      </div>
                    </div>
                    <div class="user-info width-100" *ngIf="showServiceName && showServiceName.length > 0">
                      <div class="calendar-bg">
                        <i class="far fa-tools "></i>
                      </div>
                      <div>
                        <div class="time-slot sub-heading font-14">
                          <h5>

                            <ng-container *ngFor="let service of showServiceName;let i = index">
                              {{service}}<span *ngIf="showServiceName.length - 1 > i">,</span>
                            </ng-container>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <div class="contact-us mt-3 mb-2" *ngIf="firstStepper">
              {{'appointment.please-call-us-at'|translate}} <a href="tel:{{companySetting?.phone}}"
                class="font-bold">{{companySetting?.phone |
                mask:'(000) 000-0000'}}</a>
              {{'appointment.if-you-require-our-services-urgently'|translate}}
            </div>
          </div>
          <!-- Footer buttons  -->
          <div class="footer-buttons" *ngIf="!fourthStepper">
            <div class="single-btn" *ngIf="!firstStepper">
              <button class="btn btn-lg btn-outline-secondary" (click)="onBackStepper()">
                {{'appointment.previous'|translate}}
              </button>
            </div>
            <div class="single-btn" *ngIf="!thirdStepper">
              <button class="btn btn-lg btn-primary" (click)="onNextStepper()">
                {{'appointment.next'|translate}}
              </button>
            </div>
            <div class="single-btn" *ngIf="thirdStepper">
              <button class="btn btn-lg btn-primary" (click)="onConfirmRequest()">
                {{'appointment.book-appointment'|translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isApptRequestPortalEnabled" class="no-request">
      <div class="not-found mt-3 text-center">
        {{'appointment.no-times-are-currently-available'|translate}}
      </div>
      <div class="gray-45 font-18 mt-3 text-center">
        {{'appointment.please'|translate}}
        <a href="tel:{{companySetting?.phone}}" class="font-secondary-500">
          {{'appointment.contact'|translate}}
        </a>
        {{'appointment.the-shop-directly-to-schedule-an-appointment'|translate}}
      </div>
      <div class="mt-5 flex-center-center">
        <img src="assets/no-request.jpg" class="not-found-img" />
      </div>
    </div>
    <div>
      <i *ngIf="!isFirstTimeLoad" class="rotate fas fa-spinner font-40"></i>
    </div>
  </div>

  <div class="apt-main-footer" *ngIf="isFirstTimeLoad">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <div class="contact-sec">
            <p class="mb-1">
              <i class="far fa-phone-alt font-secondary-500"></i>
              <a class="font-secondary-500" href="tel:{{companySetting?.phone}}">
                {{companySetting?.phone | mask:'(000) 000-0000'}}
              </a>
            </p>
            <p *ngIf="customerDetails.isShopAddress">
              <i class="far fa-map-pin font-secondary-500"></i>
              <a href="http://maps.google.com/?q={{companySetting.fullAddress}}"
                class="font-secondary-500 underline hover-underline" target="_blank">{{companySetting.fullAddress}}</a>
            </p>
          </div>
        </div>
        <div class="col-md-6 border-none">
          <!-- <div class="footer-brand">
            <p class="mr-2">{{'appointment.powered-by'|translate}}</p>
            <img src="assets/autoleap-green.png" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="dummy-tech-iphone-height"></div>
</div>
